import { useEffect } from 'react';

import { RentalManagerListingCriteriaType } from '@zg-rentals/ts-rental-manager-api-client';

import { useSetListingCriteriaMutation } from '../../hooks/useSetListingCriteriaMutation';
import Criterion from '../../model/ListingCriteria/Criterion';

import type { GetUserPropertyDetailsResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';
import type { CriterionProps } from '../../model/ListingCriteria/Criterion';

type Props = {
  listingAlias: string;
  listingDetails: GetUserPropertyDetailsResponseWebDto | undefined;
};

export const useListingInitialDefaults = ({ listingAlias, listingDetails }: Props) => {
  const petDefaultsMutation = useSetListingCriteriaMutation();

  useEffect(() => {
    if (!listingDetails) return;

    const petsAllowedDto = listingDetails.petsAllowed;
    const isPetsAllowedUnset =
      petsAllowedDto != null &&
      petsAllowedDto.catsDto?.allowed === undefined &&
      petsAllowedDto.smallDogsDto?.allowed === undefined &&
      petsAllowedDto.largeDogsDto?.allowed === undefined;

    if (listingDetails?.listingCriteria?.isEnabled && isPetsAllowedUnset) {
      const currentCriteria = (listingDetails.listingCriteria?.criteria ?? []) as Array<CriterionProps>;
      const getCriterion = (type: string) => currentCriteria.find((c) => c.type === type);
      const initialRefundable = getCriterion(RentalManagerListingCriteriaType.PET_POLICY_PET_DEPOSIT)?.refundable;

      petDefaultsMutation.mutate({
        getParams: { listingAlias },
        postData: [
          Criterion({ type: RentalManagerListingCriteriaType.PET_POLICY_CAT_COUNT, criterion: '0', isEnabled: true }),
          Criterion({
            type: RentalManagerListingCriteriaType.PET_POLICY_SMALL_DOG_COUNT,
            criterion: '0',
            isEnabled: true,
          }),
          Criterion({
            type: RentalManagerListingCriteriaType.PET_POLICY_LARGE_DOG_COUNT,
            criterion: '0',
            isEnabled: true,
          }),
          Criterion({
            type: RentalManagerListingCriteriaType.PET_POLICY_PET_DEPOSIT,
            criterion: '',
            refundable: initialRefundable ?? null,
            isEnabled: true,
          }),
          Criterion({ type: RentalManagerListingCriteriaType.PET_POLICY_PET_RENT, criterion: '', isEnabled: true }),
        ],
      });
    }
  }, [listingDetails]); // eslint-disable-line react-hooks/exhaustive-deps
};
